import React, { useEffect } from 'react';
import { NavLink, useParams } from 'react-router-dom';
import RunsList from './people/RunsList';
import RunDetail from './people/RunDetail';
import InactivePeople from './people/InactivePeople';
import ApproversAway from './people/ApproversAway';
import './people/People.css';

/**
 * JOINERS & LEAVERS (migration 113), under Advanced.
 *
 * Gordon, 30 October: a leaver/joiner workflow on Jarvis's own events - no
 * Microsoft Graph, so somebody added in Settings -> Users is a joiner and
 * somebody deactivated there is a leaver, and IT can start either by hand.
 * Three tabs, each with its own address:
 *
 *   /people              the checklists, open and closed
 *   /people/runs/:id     one checklist: its steps, and what is still with
 *                        the person (devices, desk, approvals) live
 *   /people/inactive     who has not signed in for 30 days - the leavers
 *                        nobody told IT about
 *   /people/away         approvers away and who decides for them
 *
 * An administrator sees all three. A member of staff who owns a checklist,
 * or has a step on one, reaches the first two from their account menu and
 * sees only those - the server decides (routes/people.js).
 */
const TABS = [
  { key: 'runs', to: '/people', label: 'Checklists' },
  { key: 'inactive', to: '/people/inactive', label: 'Not signed in', admin: true },
  { key: 'away', to: '/people/away', label: 'Approvers away', admin: true }
];

export default function PeoplePage({ view = 'runs', isAdmin = false }) {
  const { id } = useParams();
  useEffect(() => { window.scrollTo(0, 0); }, [view, id]);

  const tabs = TABS.filter((t) => isAdmin || !t.admin);
  const lit = view === 'run' ? 'runs' : view;

  return (
    <div className="container pp" data-view={view}>
      <div className="page-header pp-head">
        <h1 className="page-title">Joiners &amp; leavers</h1>
        <p className="page-description">
          {isAdmin
            ? 'The checklist for everybody arriving or going, who has not signed in for a while, and which approvers are away.'
            : 'The joiner and leaver checklists you own or have a step on.'}
        </p>
      </div>
      {tabs.length > 1 && (
        <div className="tabs-container pp-tabs">
          <nav className="tabs" aria-label="Joiners and leavers">
            {tabs.map((t) => (
              <NavLink key={t.key} to={t.to} end
                       className={`tab-button${lit === t.key ? ' active' : ''}`}
                       aria-current={lit === t.key ? 'page' : undefined}>
                {t.label}
              </NavLink>
            ))}
          </nav>
        </div>
      )}
      {view === 'runs' && <RunsList isAdmin={isAdmin} />}
      {view === 'run' && <RunDetail id={id} isAdmin={isAdmin} />}
      {view === 'inactive' && isAdmin && <InactivePeople />}
      {view === 'away' && isAdmin && <ApproversAway />}
    </div>
  );
}
